import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const ProgressCircleIcon = forwardRef(({ title = 'Progress Circle Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 16 16" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { opacity: "0.2", d: "M8 16A8 8 0 0 1 8 0a8 8 0 0 1 0 16M8 3a5 5 0 1 0 .01 10.01A5 5 0 0 0 8 3" }),
        React.createElement("path", { d: "m13.3 13.28-1.43-1.41a.5.5 0 0 1-.01-.69 5 5 0 0 0-3.38-8.16.5.5 0 0 1-.48-.5v-2a.5.5 0 0 1 .52-.5 8.01 8.01 0 0 1 5.5 13.25.5.5 0 0 1-.73.01" })));
});
//# sourceMappingURL=progress_circle_icon.js.map